import React, {useEffect} from 'react';
import SectionLayout from '../../CommonComponents/Layout/sectionLayout';
import PageHeading from '../../CommonComponents/PageHeading';
import {Button, Col, Form, Input, Row, Select} from 'antd';
import TextArea from 'antd/es/input/TextArea';
import {
  NoEmptySpaceInput,
  OnlyAlphabetInputValidator,
  OnlyAlphabetInputValidatorWithSpecialCharacters,
  formValueChangeHandler,
  validateContactDetails,
  validateEmailInput,
  validatePhoneNumber,
} from '../../../Util/commonUtility';
import './style.css';
import SponsorOptionPageHeroText from '../../CommonComponents/SponsorOptionPageHeroText';
import ComponentTitle from '../../CommonComponents/CommonComponentTitle';
import ReCAPTCHA from 'react-google-recaptcha';
import {applicationConfig} from '../../../Util/config';
import CustomCollapse from '../../CommonComponents/CommonAccordian';
import useLocalization from '../../../Localization';

const ContactUsComponent = ({chaptersOptions, submitContactForm}) => {
  const {ApplicationString} = useLocalization();
  const [form] = Form.useForm();
  const eventSubjectOptions = [
    {
      label: 'General Info',
      value: 'General Info',
    },
    {
      label: 'Ad Placement',
      value: 'Ad Placement',
    },
    {
      label: 'Sponsorship',
      value: 'Sponsorship',
    },
    {
      label: 'Vendor Services',
      value: 'Vendor Services',
    },
    {
      label: 'Others',
      value: 'Others',
    },
  ];
  const onFinish = (values) => {
    delete values.captcha;
    delete values.email_confirm;
    submitContactForm(values, form);
  };

  const onFinishFailed = (errorInfo) => {
    console.error(errorInfo);
  };

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  }, []);

  return (
    <React.Fragment>
      <Row gutter={[0, 28]} className='pbssMainContainerRow'>
        <Col span={24}>
          <SponsorOptionPageHeroText
            title={ApplicationString['userContactUsComponent.heading']}
          />
        </Col>
        <Col span={24}>
          <SectionLayout>
            <ComponentTitle
              usedForContactPage={true}
              extraClass={'ms-auto-mobile'}
              hideButton
              textColor={'black'}
              title={ApplicationString['userContactUsComponent.ThankyouText']}
              description={
                ApplicationString[
                  'userContactUsComponent.description'
                ].includes('info@pbss.org.')
                  ? ApplicationString['userContactUsComponent.description']
                      .split('info@pbss.org')
                      .map((part, index, array) => (
                        <>
                          {part}
                          {index < array.length - 1 && (
                            <a href='mailto:info@pbss.org'>info@pbss.org</a>
                          )}
                        </>
                      ))
                  : ''
              }
            />
          </SectionLayout>
        </Col>
        <Col span={24}>
          <SectionLayout>
            <div className='contact-us-container'>
              <Form
                form={form}
                name='basic'
                layout='vertical'
                onFinish={onFinish}
                onValuesChange={(changedValues) =>
                  formValueChangeHandler(form, changedValues, 'contactUs')
                }
                initialValues={''}
                onFinishFailed={onFinishFailed}
                autoComplete='off'
                className='two-column-form'>
                <div className='input-container extend-contactUs-form'>
                  <div className='form-column'>
                    <Form.Item
                      // label='Name'
                      name='name'
                      rules={[
                        {
                          required: true,
                          message:
                            ApplicationString[
                              'userContactUsFormComponent.name.validationMessage'
                            ],
                        },
                        {
                          validator: (_, value) =>
                            OnlyAlphabetInputValidatorWithSpecialCharacters(
                              value,
                              'Name',
                            ),
                        },
                      ]}>
                      <Input
                        prefix={<span style={{color: 'red'}}>*</span>}
                        prefixCls='user-common-input-user'
                        className='genral-form'
                        placeholder={
                          ApplicationString[
                            'userContactUsFormComponent.name.placeholder'
                          ]
                        }
                      />
                    </Form.Item>
                    <Form.Item
                      name='state'
                      rules={[
                        {
                          validator: (_, value) =>
                            OnlyAlphabetInputValidator(value, 'State'),
                        },
                      ]}>
                      {/* <Select
                        prefixCls='common-select-register'
                        showSearch
                        allowClear
                        optionFilterProp='children'
                        filterOption={(input, option) =>
                          (option?.label ?? '').includes(input)
                        }
                        className='space'
                        placeholder={'Select State / Proviance'}
                        options={[]}></Select> */}
                      <Input
                        prefixCls='user-common-input-user'
                        className='genral-form'
                        placeholder={
                          ApplicationString[
                            'userContactUsFormComponent.state.placeholder'
                          ]
                        }
                      />
                    </Form.Item>
                    <Form.Item
                      name='email'
                      rules={[
                        {
                          required: true,
                          message:
                            ApplicationString[
                              'userContactUsFormComponent.email.validationMessage'
                            ],
                        },
                        {
                          validator: (_, value) =>
                            validateEmailInput(value, 'Email'),
                        },
                      ]}>
                      <Input
                        prefix={<span style={{color: 'red'}}>*</span>}
                        prefixCls='user-common-input-user'
                        className='genral-form'
                        placeholder={
                          ApplicationString[
                            'userContactUsFormComponent.email.placeholder'
                          ]
                        }
                      />
                    </Form.Item>
                    <Form.Item
                      name='phoneNumber'
                      rules={[
                        {
                          validator: (_, value) =>
                            validatePhoneNumber(value, 'Phone number'),
                        }, // Custom validator
                      ]}>
                      <Input
                        prefixCls='user-common-input-user'
                        className='genral-form'
                        placeholder={
                          ApplicationString[
                            'userContactUsFormComponent.phoneNumber.placeholder'
                          ]
                        }
                      />
                    </Form.Item>
                  </div>
                  <div className='form-column'>
                    <Form.Item
                      name='city'
                      rules={[
                        {
                          validator: (_, value) =>
                            OnlyAlphabetInputValidator(value, 'City'),
                        },
                      ]}>
                      {/* <Select
                        prefixCls='common-select-register'
                        showSearch
                        allowClear
                        optionFilterProp='children'
                        filterOption={(input, option) =>
                          (option?.label ?? '').includes(input)
                        }
                        className='space'
                        placeholder={
                          ApplicationString[
                            'userContactUsFormComponent.selectCity.placeholder'
                          ]
                        }
                        options={[]}></Select> */}
                      <Input
                        prefixCls='user-common-input-user'
                        className='genral-form'
                        placeholder={
                          ApplicationString[
                            'userContactUsFormComponent.selectCity.placeholder'
                          ]
                        }
                      />
                    </Form.Item>
                    <Form.Item
                      name='country'
                      rules={[
                        {
                          validator: (_, value) =>
                            OnlyAlphabetInputValidator(value, 'Country'),
                        },
                      ]}>
                      {/* <Select
                        prefixCls='common-select-register'
                        showSearch
                        allowClear
                        optionFilterProp='children'
                        filterOption={(input, option) =>
                          (option?.label ?? '').includes(input)
                        }
                        className='space'
                        placeholder={
                          ApplicationString[
                            'userContactUsFormComponent.selectCountry.placeholder'
                          ]
                        }
                        options={[]}></Select> */}
                      <Input
                        prefixCls='user-common-input-user'
                        className='genral-form'
                        placeholder={
                          ApplicationString[
                            'userContactUsFormComponent.selectCountry.placeholder'
                          ]
                        }
                      />
                    </Form.Item>
                    <Form.Item
                      name='email_confirm'
                      rules={[
                        {
                          required: true,
                          message:
                            ApplicationString[
                              'userContactUsFormComponent.emailConfirm.validationMessage'
                            ],
                        },
                        {
                          validator: (_, value) => {
                            validateEmailInput(value, 'Email');
                            if (
                              !value ||
                              form.getFieldValue('email') === value
                            ) {
                              return Promise.resolve();
                            } else {
                              return Promise.reject(
                                new Error('Email IDs must match'),
                              );
                            }
                          },
                        },
                      ]}>
                      <Input
                        prefix={<span style={{color: 'red'}}>*</span>}
                        prefixCls='user-common-input-user'
                        className='genral-form'
                        placeholder={
                          ApplicationString[
                            'userContactUsFormComponent.emailConfirm.placeholder'
                          ]
                        }
                      />
                    </Form.Item>
                    <Form.Item name='affiliation'>
                      <Select
                        prefixCls='common-select-contact'
                        showSearch
                        allowClear
                        optionFilterProp='children'
                        filterOption={(input, option) =>
                          String(option?.label ?? '')
                            .toLowerCase()
                            .includes(String(input ?? '').toLowerCase())
                        }  
                        className='space'
                        placeholder={
                          ApplicationString[
                            'userContactUsFormComponent.selectAffiliation.placeholder'
                          ]
                        }
                        options={chaptersOptions}></Select>
                      {/* <Input
                        prefixCls='user-common-input-user'
                        className='genral-form'
                        placeholder={
                          ApplicationString[
                            'userContactUsFormComponent.selectAffiliation.placeholder'
                          ]
                        }
                      /> */}
                    </Form.Item>
                  </div>
                </div>
                <div className='input-container'>
                  <div className='form-column'>
                    <Form.Item
                      name='topic'
                      rules={[
                        {
                          required: true,
                          message:
                            ApplicationString[
                              'userContactUsFormComponent.inquiry.validationMessage'
                            ],
                        },
                        {
                          validator: (_, value) =>
                            NoEmptySpaceInput(value, 'Inquiry Title'),
                        },
                      ]}>
                      <Input
                        prefix={<span style={{color: 'red'}}>*</span>}
                        prefixCls='user-common-input-user'
                        className='genral-form'
                        placeholder={
                          ApplicationString[
                            'userContactUsFormComponent.inquiry.placeholder'
                          ]
                        }
                      />
                    </Form.Item>
                  </div>
                  <div className='form-column'>
                    <Form.Item name='emailSubject'>
                      <Select
                        prefixCls='common-select-contact'
                        showSearch
                        allowClear
                        optionFilterProp='children'
                        filterOption={(input, option) =>
                          (option?.label ?? '')
                            .toLowerCase()
                            .includes(input?.toLowerCase() ?? '')
                        }
                        className='space'
                        placeholder={
                          ApplicationString[
                            'userContactUsFormComponent.selectEmailSubject.placeholder'
                          ]
                        }
                        options={eventSubjectOptions}></Select>
                    </Form.Item>
                  </div>
                </div>
                <div className='input-container'>
                  <div className='form-column'>
                    <Form.Item
                      name='comments'
                      prefixCls='contactus-textarea'
                      rules={[
                        {
                          required: true,
                          message:
                            ApplicationString[
                              'userContactUsFormComponent.description.validationMessage'
                            ],
                        },
                        {
                          validator: (_, value) =>
                            validateContactDetails(value, 'Details'),
                        },
                      ]}>
                      <div className='mandatory-formItem-textarea'>
                        *
                        <textarea
                          prefixCls='user-common-input-user'
                          className='user-common-input-user genral-form extend-contactUs remove-boxshadow'
                          placeholder={
                            ApplicationString[
                              'userContactUsFormComponent.description.placeholder'
                            ]
                          }
                        />
                      </div>
                    </Form.Item>
                  </div>
                </div>
                <div className='input-container'>
                  <div className='form-column'>
                    <Form.Item>
                      <p className='re-captcha-label-login'>
                        {
                          ApplicationString[
                            'userContactUsComponent.captchaText'
                          ]
                        }
                      </p>
                      <Form.Item
                        name='captcha'
                        noStyle
                        rules={[
                          {
                            required: true,
                            message:
                              ApplicationString[
                                'userContactUsFormComponent.captcha.validationMessage'
                              ],
                          },
                        ]}>
                        <ReCAPTCHA
                          sitekey={
                            applicationConfig.CAPTCHA_SITE_KEY
                          }></ReCAPTCHA>
                      </Form.Item>
                    </Form.Item>
                  </div>
                </div>
                <Form.Item>
                  <div className='button-container'>
                    <Button
                      id='contactUs-submitFeedback-button'
                      type='primary'
                      htmlType='submit'
                      className='user-common-submit-login common-form-submit contact-us-button'>
                      {
                        ApplicationString[
                          'dynamicSearch.button.submit-your-feedback'
                        ]
                      }
                    </Button>
                  </div>
                </Form.Item>
              </Form>
            </div>
          </SectionLayout>
        </Col>
        <Col span={24}>
          <SectionLayout>
            <CustomCollapse />
          </SectionLayout>
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default ContactUsComponent;
